import { useDispatch } from "react-redux";
import { message } from "antd";
import { useReindexDatasetApiV1DatasetDatasetIdReindexPost } from "vl-api/vlComponents";
import { fetchDataset } from "redux/SingleDataset/actions";

interface UseReindexOptions {
  onSuccess?: () => void;
  onError?: (error?: any) => void;
  successMessage?: string;
  errorMessage?: string;
}

export const useReindex = (datasetId?: string, options?: UseReindexOptions) => {
  const dispatch = useDispatch();

  const {
    onSuccess,
    onError,
    successMessage = "Dataset reindexing started successfully!",
    errorMessage = "Failed to start dataset reindexing. Please try again.",
  } = options || {};

  const reindexMutation = useReindexDatasetApiV1DatasetDatasetIdReindexPost({
    onSuccess: () => {
      message.success(successMessage);
      if (datasetId) {
        dispatch(fetchDataset(datasetId) as any);
      }
      onSuccess?.();
    },
    onError: (error) => {
      message.error(errorMessage);
      onError?.(error);
    },
  });

  const reindex = () => {
    if (!datasetId) {
      message.error("Dataset ID not found");
      return;
    }

    reindexMutation.mutate({
      pathParams: { datasetId },
    });
  };

  return {
    reindex,
    isLoading: reindexMutation.isPending,
    error: reindexMutation.error,
  };
};
